import {trackPromise} from "react-promise-tracker";
import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";

export const requestOTPAsync = (payload) => {
  const url = getUrl("login");
  return trackPromise(Call.post(url, payload));
};

export const validateOTPAsync = (payload) => {
  const url = getUrl("loginOTP");
  return trackPromise(Call.post(url, payload));
};

export const verifyPhoneNumberAsync = (payload) => {
  const url = getUrl("verifyPhone");
  return trackPromise(Call.post(url, payload));
};
